export const TOKEN_KEY = 'token';
export const TOKEN_STATUS_KEY = 'token-status';

export const NOT_AUTHORISED_MESSAGE =
  'You are not authorised to access this application. Please contact admin!';
